import React from "react";
import { Container } from "@mui/material";
// import { styled } from "@mui/material/styles";
import Successmark from "../../../assets/images/Successmark.png";
import MainButton from "../../shared/Button";
import { useNavigate } from "react-router-dom";
import {
  PendingApprovalMain,
  PendingImg,
  PendingText,
} from "./styles/ProfilePasswordChangeStyle";

const PasswordSuccessfull = () => {
  const navigate = useNavigate();
  return (
    <>
      <Container maxWidth="lg">
        <PendingApprovalMain>
          <PendingImg>
            <img src={Successmark} alt="Successmark" />
          </PendingImg>
          <PendingText>
            <h6>Password Changed!</h6>
            <p>Congratulations! Your password is successfully changed.</p>
          </PendingText>
          <MainButton
            type="button"
            label="Done"
            MT="140"
            onClick={() => navigate("/login")}
          />
        </PendingApprovalMain>
      </Container>
    </>
  );
};

export default PasswordSuccessfull;
